/*
 * cm-checkout-confirm — intercepts any [data-cm-checkout-confirm] button
 * (the cart page, cart drawer and cart notification checkout buttons) and
 * shows the shared safety-gear popup instead of letting it submit straight
 * away. Confirming re-submits the original form via requestSubmit(button)
 * so the button's own name/value (Shopify's cue to redirect to checkout)
 * is still included, exactly as a normal click would have sent it.
 *
 * Delegated on document rather than bound per-button, so it keeps working
 * after the cart notification re-renders its markup on every add-to-cart.
 */
(() => {
  const dialog = document.querySelector('[data-cm-checkout-confirm-dialog]');
  if (!dialog || dialog.dataset.cmBound) return;
  dialog.dataset.cmBound = 'true';

  const checkboxes = Array.from(dialog.querySelectorAll('[data-cm-checkout-confirm-checkbox]'));
  const continueBtn = dialog.querySelector('[data-cm-checkout-confirm-continue]');
  const cancelBtn = dialog.querySelector('[data-cm-checkout-confirm-cancel]');
  let pendingButton = null;

  const reset = () => {
    checkboxes.forEach((box) => { box.checked = false; });
    continueBtn.disabled = true;
    pendingButton = null;
  };

  checkboxes.forEach((box) => {
    box.addEventListener('change', () => {
      continueBtn.disabled = !checkboxes.every((b) => b.checked);
    });
  });

  cancelBtn.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', reset);

  continueBtn.addEventListener('click', () => {
    const button = pendingButton;
    dialog.close();
    if (!button) return;
    const form = button.form;
    if (!form) return;
    if (form.requestSubmit) {
      form.requestSubmit(button);
    } else {
      form.submit();
    }
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cm-checkout-confirm]');
    if (!button || button.disabled) return;
    event.preventDefault();
    pendingButton = button;
    dialog.showModal();
  });
})();
